import React, { useState } from 'react';
import { QrCode, RefreshCw, Power } from 'lucide-react';
import { Panel, RowButton, PageHeading } from '../ui';
export function QrManagement() {
  const [active, setActive] = useState(true);
  const [seed, setSeed] = useState(1);
  return <div data-id="element-560" data-mp="3fp8ivnn0oxmc">
      <PageHeading title="QR Code Management" subtitle="A single, non-school-specific Family App QR. Scanning it sets user type → Parent and loads the WebView." data-id="element-561" data-mp="3foyrbvmbqiej" />

      <div className="grid gap-5 lg:grid-cols-2" data-id="element-562" data-mp="2n0jg7k6bck8h">
        <Panel title="Family App QR Code" icon={<QrCode className="h-4 w-4 text-[#1e2a5a]" data-id="element-564" data-mp="2i1q1xpj7cp79" />} data-id="element-563" data-mp="2i4c8pmy9r0of">
          <div className="flex flex-col items-center gap-4 p-6" data-id="element-565" data-mp="2wu08ukuprtak">
            <div className={`rounded-xl border-4 p-4 transition ${active ? 'border-[#1e2a5a]' : 'border-slate-200 opacity-40'}`} data-id="element-566" data-mp="2s177m6ygf338">
              <QrGlyph seed={seed} data-id="element-567" data-mp="1zdbd98wcxn9m" />
            </div>
            <span className={`rounded-full px-3 py-1 text-xs font-semibold ${active ? 'bg-emerald-100 text-emerald-700' : 'bg-slate-100 text-slate-500'}`} data-id="element-568" data-mp="1zct6vjfzdsnz">
              {active ? 'Active' : 'Deactivated'}
            </span>
            <div className="flex gap-2" data-id="element-569" data-mp="symar9n23sy4">
              <RowButton variant="edit" onClick={() => setSeed(s => s + 1)} data-id="element-570" data-mp="xvmj5r7dp7se">
                <span className="flex items-center gap-1" data-id="element-571" data-mp="16ola04c0tr0">
                  <RefreshCw className="h-3.5 w-3.5" data-id="element-572" data-mp="565rivrl1ux8" />
                  Regenerate
                </span>
              </RowButton>
              <RowButton variant={active ? 'danger' : 'read'} onClick={() => setActive(a => !a)} data-id="element-573" data-mp="a50gkfg58fps">
                <span className="flex items-center gap-1" data-id="element-574" data-mp="1lkxhz3564s3w">
                  <Power className="h-3.5 w-3.5" data-id="element-575" data-mp="1lkfjdzv1a1st" />
                  {active ? 'Deactivate' : 'Activate'}
                </span>
              </RowButton>
            </div>
          </div>
        </Panel>

        <Panel title="Details" icon={<QrCode className="h-4 w-4 text-[#1e2a5a]" data-id="element-577" data-mp="vwtjgcf2oxpw" />} data-id="element-576" data-mp="10u1rhk6ibldf">
          <dl className="divide-y divide-slate-100 text-sm" data-id="element-578" data-mp="vw0bx98ai46p">
            {[['Type', 'Family App (global)'], ['School-specific', 'No — single code'], ['Routes to', 'Screen 8 · Family App WebView'], ['Sets user type', 'Parent (guest)'], ['Scanner', 'Screen 12 · 4th function'], ['Code ID', `RGT-FAM-000${seed}`]].map(([k, v]) => <div key={k} className="flex justify-between px-5 py-3" data-id="element-579" data-mp="d4h6ywupgg21">
                <dt className="text-slate-500" data-id="element-580" data-mp="rwrg7ytovw8i">{k}</dt>
                <dd className="font-medium text-slate-800" data-id="element-581" data-mp="n4ri8bx6jdek">{v}</dd>
              </div>)}
          </dl>
        </Panel>
      </div>
    </div>;
}
function QrGlyph({
  seed
}: {
  seed: number;
}) {
  // Deterministic pseudo-random QR-ish grid.
  const cells = Array.from({
    length: 25 * 25
  }, (_, i) => {
    const v = (i * 9301 + seed * 49297) % 233280;
    return v % 3 !== 0;
  });
  return <div className="grid gap-px" style={{
    gridTemplateColumns: 'repeat(25, 6px)'
  }} aria-label="Family App QR code" data-id="element-582" data-mp="2atmfjffvq0k5">
      {cells.map((on, i) => <span key={i} className={`h-1.5 w-1.5 ${on ? 'bg-[#1e2a5a]' : 'bg-transparent'}`} data-id="element-583" data-mp="1w35c5qjop0km" data-mpi={i} />)}
    </div>;
}